import { AuthenticationTypes } from '../constants';

(() => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (window.elma) {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.elma = {
    assistant: {
      info: {
        configuration: {
          client: {
            services: {
              gamma: {
                publicUrl: window.location.origin,
              },
            },
          },
        },
      },
    },
  };
})();

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const CLIENT_CONFIG = window.elma.assistant.info.configuration.client;

export const PUBLIC_URL: string = CLIENT_CONFIG.services.gamma.publicUrl;

export const AUTH_TYPE: AuthenticationTypes = CLIENT_CONFIG.services.gamma.authentication as AuthenticationTypes;

export const BASE_PATH: string = new URL(PUBLIC_URL).pathname.replace(/\/$/, '');

export const GAMMA_INTERNAL_API_BASE_PATH = '/api/int/v1';

export const GAMMA_SECURITY_AUTH_PATH = `${GAMMA_INTERNAL_API_BASE_PATH}/security/auth`;
export const GAMMA_LOGIN_PATH = `${GAMMA_SECURITY_AUTH_PATH}/login`;
export const GAMMA_LOGOUT_PATH = `${GAMMA_SECURITY_AUTH_PATH}/logout`;

export const trimBasePath = (fullPath: string): string => (BASE_PATH ? fullPath.substring(BASE_PATH.length) : fullPath);

export const getCurrentPath = (subPath: string): string => `${BASE_PATH}${subPath}`;

export const getCurrentUrl = (fullPath: string): string => `${window.location.origin}${fullPath}`;

export const LOCALE_PATH: string = getCurrentPath('/locales/{{lng}}/{{ns}}.json');

export const getServerUrl = (publicUrl: string, subPath?: string): string =>
  subPath ? `${publicUrl}${subPath}` : publicUrl;

export const AUTH_SERVER_URL = CLIENT_CONFIG.services.authServer.publicUrl;
